import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  TextField,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Autocomplete,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PrintIcon from "@mui/icons-material/Print";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
// import AddIcon from '@mui/icons-material/Add';
import {
  branchpartyList,
  getBillsByPartyApi,
  paymentsCreate,
  paymentList,
} from "../../Services/Services";
import { useEffect, useMemo } from "react";

const PaymentTable = () => {

  const [partyOptions, setParties] = useState([]);
  const [branchOptions, setBranch] = useState([]);
  const [billList, setBillList] = useState([]);
  const [payment, setpayment] = useState([]);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    branch_id: null,
    party_id: null,
    freight_id: null,
    bal_amount: "",
    pay_amount: "",
    rem_amount: "",
    description: "",
    payment_mode: "",
  });
  const fetchBranchParties = async () => {
    const data = await branchpartyList();
    if (data) {
      setParties(data.party);
      setBranch(data.branch);
    }
  };

  const fetchpayment = async () => {
    const data = await paymentList();
    if (data) {
      setpayment(data);
    }
  };
  useEffect(() => {
    fetchBranchParties();
    fetchpayment();
  }, []);
  const getBillsByParty = async (party_id) => {
    try {
      const response = await getBillsByPartyApi(party_id);
      setBillList(response || []);
    } catch (error) {
      console.error("Error fetching freights:", error);
      setBillList([]);
    }
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const freight_list = billList.find(
      (f) => f.billing_id === formData.billing_id
    );
    const freight_id = freight_list.freights.map((item) => item.freight_id);
    formData.freight_id = freight_id;
    const response = await paymentsCreate(formData);
    if (response) {
      setpayment(response);
      setOpen(false);
      setFormData({
        branch_id: null,
        party_id: null,
        freight_id: null,
        total_amount: "",
        paid_amount: "",
        bal_amount: "",
        pay_amount: "",
        rem_amount: "",
        description: "",
        upi_check_no: "",
        payment_mode: "",
        payment_to: "",
      });
    }
  };

  const handleExportExcel = () => {
    const table = document.getElementById("freight-payment");
    const rows = Array.from(table.querySelectorAll("tr"));
    const ws_data = [];

    rows.forEach((row) => {
      const cells = Array.from(row.querySelectorAll("th, td"));
      const rowData = cells
        .filter((cell) => !cell.classList.contains("no-print"))
        .map((cell) => cell.innerText);
      ws_data.push(rowData);
    });

    const ws = XLSX.utils.aoa_to_sheet(ws_data);

    const colWidths = ws_data[0].map((_, colIndex) => {
      const maxLength = ws_data.reduce((max, row) => {
        const cell = row[colIndex];
        const len = cell ? cell.toString().length : 10;
        return Math.max(max, len);
      }, ws_data[0][colIndex].length);
      return { wch: maxLength + 2 };
    });
    ws["!cols"] = colWidths;

    const blackBorder = {
      top: { style: "thin", color: { rgb: "000000" } },
      bottom: { style: "thin", color: { rgb: "000000" } },
      left: { style: "thin", color: { rgb: "000000" } },
      right: { style: "thin", color: { rgb: "000000" } },
    };

    const headerLength = ws_data[0].length;
    for (let c = 0; c < headerLength; c++) {
      const cell = ws[XLSX.utils.encode_cell({ r: 0, c })];
      if (cell) {
        cell.s = {
          fill: { fgColor: { rgb: "FFFF99" } },
          font: { bold: true, color: { rgb: "000000" } },
          alignment: { horizontal: "center", vertical: "center" },
          border: blackBorder,
        };
      }
    }

    for (let r = 1; r < ws_data.length; r++) {
      for (let c = 0; c < headerLength; c++) {
        const cell = ws[XLSX.utils.encode_cell({ r, c })];
        if (cell) {
          cell.s = {
            alignment: { horizontal: "center", vertical: "center" },
            border: blackBorder,
          };
        }
      }
    }

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "FreightPayment");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "Freight_Payment_List.xlsx");
  };

  const handlePrintHTML = () => {
    const table = document.getElementById("freight-payment");
    if (!table) return;

    const printContent = table.outerHTML;
    const printWindow = window.open("", "", "width=1000,height=600");

    printWindow.document.write(`
      <html>
      <head>
        <style>
          body {
            font-family: Arial, sans-serif;
            padding: 0px 20px 0px 20px;
          }
          header {
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 20px;
            color: #333;
          }
          footer {
            position: fixed;
            bottom: 10px;
            width: 100%;
            text-align: center;
            font-size: 12px;
            color: #333;
          }
          table {
            width: 100%;
            border-collapse: collapse;
          }
          th, td {
            border: 1px solid black;
            padding: 8px;
            text-align: center;
            font-size: 12px;
          }
          th {
            background-color: rgba(211, 211, 211, 0.42);
            color: #000;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          .no-print {
            display: none;
          }
        </style>
      </head>
      <body>
        <header>SR ENTERPRICES</header>
        <h3 style="text-align: center;">LR Payment List</h3>
        ${printContent}
        <footer>Powered by : YASHVITECH IT SOLUTION PVT LTD</footer>
        <script>
          window.onload = function() {
            window.print();
            window.onafterprint = function() {
              window.close();
            };
          };
        </script>
      </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
  };
  const getInitials = (str) => {
    return str
      .split(" ")
      .filter((word) => word)
      .map((word) => word[0])
      .join("")
      .toUpperCase();
  };
  const [filters, setFilters] = useState({
    branch: "",
    billId: "",
    freightId: "",
    party: "",
  });
  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  const filteredData = useMemo(() => {
    return payment.filter((row) => {
      const matchBranch = filters.branch
        ? row.branch_name?.toLowerCase().includes(filters.branch.toLowerCase())
        : true;
      const matchBillingId = filters.billId
        ? row.billing_id?.toString().includes(filters.billId.trim())
        : true;

      const matchParty = filters.party
        ? row.party_name?.toLowerCase().includes(filters.party.toLowerCase())
        : true;

      return matchBranch && matchBillingId && matchParty;
    });
  }, [filters, payment]);

  return (
    <div style={{ width: "100%", maxHeight: "calc(100vh - 70px)" }}>
      <Box
        sx={{
          mb: 2,
          display: "flex",
          alignItems: "center",
          gap: 2,
          py: 1,
          flexWrap: "wrap",
          position: "sticky",
          top: 10,
          zIndex: 1000,
        }}
      >
   <Grid item xs={12} sm={3} style={{ padding: 10 }}>
        <TextField
          label="Search by Branch Name"
          size="small"
          fullWidth
          value={filters.branch}
          onChange={(e) => handleFilterChange("branch", e.target.value)}
        />
        </Grid>
           <Grid item xs={12} sm={3} style={{ padding: 10 }}>
        <TextField
          label="Search by Ref No"
          size="small"
          fullWidth
          value={filters.billId}
          onChange={(e) => handleFilterChange("billId", e.target.value)}
        />
        </Grid>
           <Grid item xs={12} sm={3} style={{ padding: 10 }}>
        <TextField
          label="Search by Party Name"
          size="small"
          fullWidth
          value={filters.party}
          onChange={(e) => handleFilterChange("party", e.target.value)}
        />
        </Grid>
          <Grid item xs={12} sm={3} style={{ padding: 10 }}>
        <Button
          variant="outlined"
          onClick={handleExportExcel}
          sx={{ minWidth: "40px", height: "40px", margin: 1 }}
        >
          <FileDownloadIcon fontSize="small" />
        </Button>
        <Button
          variant="outlined"
          onClick={handlePrintHTML}
          sx={{ minWidth: "40px", height: "40px", margin: 1 }}
        >
          <PrintIcon fontSize="small" />
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleOpen(true)}
        //   startIcon={<AddIcon />}
        >
          Add
        </Button>
        </Grid>
      </Box>

      {/* Table */}
      <TableContainer sx={{ overflowX: "auto", width: "100%" }}>
        <div style={{ maxHeight: "75vh", overflowX: "auto" }}>
          <Table
            stickyHeader
            size="small"
            id="freight-payment"
            sx={{
              width: "100%",
              tableLayout: "fixed",
              "& td, & th": {
                textAlign: "center",
                whiteSpace: "nowrap",
                padding: "0px 8px",
                fontSize: "0.8125rem",
                borderBottom: "1px solid #ccc",
              },
            }}
          >
            <TableHead>
              <TableRow
                sx={{
                  "& th": {
                    fontWeight: "bold",
                    color: (theme) =>
                      theme.palette.mode === "dark" ? "#2196f3" : "#333",
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                  },
                }}
              >
                <TableCell>Sr No.</TableCell>
                <TableCell>Pay Id</TableCell>
                <TableCell>Party </TableCell>
                <TableCell>Branch</TableCell>
                <TableCell>Ref No.</TableCell>
                <TableCell>Paid Amt</TableCell>
                <TableCell>Pay Mode</TableCell>
                <TableCell>Remark</TableCell>
                {/* <TableCell align="center" className="no-print">
                Actions
              </TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                    "& td": {
                      color: (theme) =>
                        theme.palette.mode === "dark" ? "white" : "inherit",
                      backgroundColor: (theme) =>
                        theme.palette.mode === "dark" ? "black" : "inherit",
                    },
                  }}
                >
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.payment_id}</TableCell>
                  <TableCell
                    sx={{
                      maxWidth: "120px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {row.party_name}
                  </TableCell>
                  <TableCell
                    sx={{
                      maxWidth: "120px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {row.branch_name}
                  </TableCell>
                  <TableCell>
                    {row.branch_name === "RAIPUR"
                      ? "SRE"
                      : row.branch_name === "BILASPUR"
                        ? "JHT"
                        : "MBR"}
                    /{row.billing_id}/{getInitials(row.party_name)}
                  </TableCell>
                  <TableCell>{row.pay_amount}</TableCell>
                  <TableCell>{row.payment_mode}</TableCell>

                  <TableCell>{row.description}</TableCell>
                  {/* <TableCell
                  align="center"
                  className="no-print"
                  sx={{
                    position: "sticky",
                    right: 0,
                    backgroundColor: "#fff",
                    zIndex: 1,
                  }}
                >
                  <IconButton
                    color="primary"
                    size="small"
                    onClick={() => handleEdit(row)}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    color="error"
                    size="small"
                    onClick={() => handleDelete(row)}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </TableCell> */}
                </TableRow>
              ))}
            </TableBody>
            <TableRow
              sx={{
                backgroundColor: "#e3f2fd",
                fontWeight: "bold",
              }}

            >
              <TableCell colSpan={5} align="right">
                Total:
              </TableCell>
              <TableCell align="center">
                {filteredData.reduce(
                  (accumulator, currentValue) =>
                    accumulator + (+currentValue.pay_amount || 0),
                  0
                ).toFixed(1)}
              </TableCell>

              <TableCell colSpan={2} align="right"></TableCell>


            </TableRow>
          </Table>
        </div>
      </TableContainer>

      {/*Dialog Box */}
      <Dialog open={open} maxWidth="md" fullWidth>
        <form onSubmit={handleSubmit}>
          <DialogTitle>Add Payment</DialogTitle>
          <DialogContent>
            <Box component="form" noValidate sx={{ mt: 2 }}>
              <Grid container spacing={2}>
                {/* Branch Dropdown */}
                <Grid item xs={12} sm={6}>
                  <Autocomplete
                    options={branchOptions}
                    getOptionLabel={(option) => option?.branch_name || ""}
                    value={
                      branchOptions.find(
                        (b) => b.branch_id === formData.branch_id
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      setFormData((prev) => ({
                        ...prev,
                        branch_id: newValue?.branch_id || "",
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Branch Name"
                        variant="outlined"
                        size="medium"
                        required
                        sx={{ "& .MuiInputBase-root": { height: "45px" } }}
                      />
                    )}
                  />
                </Grid>

                {/* Party Dropdown */}
                <Grid item xs={12} sm={6}>
                  <Autocomplete
                    options={partyOptions}
                    getOptionLabel={(option) => option?.name || ""}
                    value={
                      partyOptions.find(
                        (p) => p.party_id === formData.party_id
                      ) || null
                    }
                    onChange={async (event, newValue) => {
                      setFormData((prev) => ({
                        ...prev,
                        party_id: newValue?.party_id || "",
                      }));

                      if (newValue?.party_id) {
                        await getBillsByParty(newValue.party_id);
                      } else {
                        setBillList([]);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Party Name"
                        variant="outlined"
                        size="medium"
                        required
                        sx={{ "& .MuiInputBase-root": { height: "45px" } }}
                      />
                    )}
                  />
                </Grid>

                {/* LR ID Dropdown */}
                <Grid item xs={12} sm={6}>
                  <Autocomplete
                    options={billList}
                    getOptionLabel={(option) =>
                      option?.freights
                        ? `Ref No.- ${option.branch_name === "RAIPUR"
                          ? "SRE"
                          : option.branch_name === "BILASPUR"
                            ? "JHT"
                            : "MBR"
                        }/${option.billing_id}/${getInitials(
                          option.party_name
                        )}`
                        : ""
                    }
                    value={
                      billList.find(
                        (f) => f.billing_id === formData.billing_id
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      setFormData((prev) => ({
                        ...prev,
                        billing_id: newValue?.billing_id || "",
                        bal_amount: newValue?.rem_amount || "",
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Bill ID"
                        variant="outlined"
                        required
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    name="bal_amount"
                    label="Total Bal Amount"
                    type="number"
                    value={formData.bal_amount}
                    onChange={handleChange}
                    disabled
                    required
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    name="pay_amount"
                    label=" Rec Amount"
                    type="number"
                    value={formData.pay_amount}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    name="rem_amount"
                    label="Rem Amount"
                    type="number"
                    value={(
                      Number(formData.bal_amount) - Number(formData.pay_amount)
                    ).toFixed(2)}
                    onChange={handleChange}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    name="payment_mode"
                    label="Payment Mode"
                    rows={3}
                    value={formData.payment_mode}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    name="description"
                    label="Description"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </Grid>
              </Grid>
            </Box>
          </DialogContent>

          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button variant="contained" type="submit">
              Submit
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
};

export default PaymentTable;
